import { Color } from "@/types/Message";
export const color_mapping: { [key in Color]: string } = {
  // Blue: "#70E0E6",
  // Green: "#B8E670",
  // Red: "#EF694A",
  "Light Blue": "#ABE3FA",
  Blue: "#5F94D6",
  Green: "#65C77D",
  Red: "#E6817E",
  Purple: "#9B86F3",
  Pink: "#EBA4E4",
  Yellow: "#F8EDB1",
  Orange: "#E6A575",
  Grey: "#CECECE",
  Black: "#4D4D4D",
  White: "#FDFEFE",
};
export const font_color_mapping: { [key in Color]: string } = {
  "Light Blue": "#020307",
  Blue: "#020307",
  Green: "#020307",
  Red: "#020307",
  Purple: "#020307",
  Pink: "#020307",
  Yellow: "#020307",
  Orange: "#020307",
  Grey: "#020307",
  Black: "#FDFEFE",
  White: "#020307",
};

export function hexToRgb(
  hex: string,
): { r: number; g: number; b: number } | null {
  // FROM https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}
// https://stackoverflow.com/questions/66123016/interpolate-between-two-colors-based-on-a-percentage-value

const is = {
  hex: (a: string) => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a),
  rgb: (a: string) => /^rgb/.test(a),
  hsl: (a: string) => /^hsl/.test(a),
  col: (a: string) => is.hex(a) || is.rgb(a) || is.hsl(a),
};

export const hexToRgba = (color: string, alpha: number = 1) => {
  const colorMatch = color.match(/\w\w/g);
  if (colorMatch != null) {
    const [r, g, b] = colorMatch.map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return null;
};

export function rgbaToHex(orig: string) {
  let a;
  const rgb = orig
    .replace(/\s/g, "")
    .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
  const alpha = ((rgb && rgb[4]) || "").trim();
  let hex = rgb
    ? (Number(rgb[1]) | (1 << 8)).toString(16).slice(1) +
      (Number(rgb[2]) | (1 << 8)).toString(16).slice(1) +
      (Number(rgb[3]) | (1 << 8)).toString(16).slice(1)
    : orig;

  if (alpha !== "") {
    a = Number(alpha);
  } else {
    a = 1;
  }
  // multiply before convert to HEX
  a = ((a * 255) | (1 << 8)).toString(16).slice(1);
  hex = hex + a.toString();

  return hex;
}

export const rbgToRgba = (color: string, alpha: number = 1) => {
  const [r, g, b] = color.replace(/[^\d,]/g, "").split(",");
  return `rgba(${r},${g},${b},${alpha})`;
};

export const deconstructRgba = (rgba: string) => {
  return rgba
    .replace(/[^\d,]/g, "")
    .split(",")
    .map((x) => parseInt(x));
};

export const formatRbga = (color: {
  r: number;
  g: number;
  b: number;
  a: number;
}) => {
  return `rgba(${color.r},${color.g},${color.b},${color.a})`;
};

export const interpolateColor = (
  colorA: string,
  colorB: string,
  progress: number,
) => {
  const rgbaColorA = hexToRgba(colorA);
  const rgbaColorB = hexToRgba(colorB);
  if (rgbaColorA && rgbaColorB) {
    const [r1, g1, b1, a1] = deconstructRgba(rgbaColorA);
    const [r2, g2, b2, a2] = deconstructRgba(rgbaColorB);
    return formatRbga({
      r: Math.round(r1 + (r2 - r1) * progress),
      g: Math.round(g1 + (g2 - g1) * progress),
      b: Math.round(b1 + (b2 - b1) * progress),
      a: Math.round(a1 + (a2 - a1) * progress),
    });
  }
  return null;
};
